@if (administrations.length > 1) {
  <div class="uf-select-administration">
    <mat-label>Administratie: </mat-label>
    <mat-form-field>
      <mat-select [(value)]="administration" (selectionChange)="administrationChange.emit($event.value);">
        @for (administration of administrations; track administration.uuid) {
          <mat-option [value]="administration">{{administration.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}
